import React, { useState } from 'react';
import Modal from 'react-modal';

const CompaniesModal = ({ isOpen, onClose, companies, onSelectCompany }) => {
  const [search, setSearch] = useState('');

  const filtered = companies.filter((c) =>
    c.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (name) => {
    if (onSelectCompany) onSelectCompany(name);
    setSearch('');
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Partner Companies"
      className="leader-con-modal partner-companies-modal"
      overlayClassName="leader-con-modal-overlay"
    >
      <div className="leader-con-modal-header">
        <h2 className="leader-con-modal-title">Partner Companies</h2>
        <button type="button" className="leader-con-modal-close-button" onClick={onClose}>
          &times;
        </button>
      </div>
      <div className="leader-con-modal-search">
        <input
          type="text"
          className="leader-con-modal-search-bar"
          placeholder="Search companies..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className="leader-con-modal-content">
        <ul className="leader-con-breakdown-list">
          {filtered.map((company) => (
            <li key={company.name} className="leader-con-breakdown-item lead-company-list-item">
              <button
                type="button"
                className="lead-company-select-btn"
                onClick={() => handleSelect(company.name)}
              >
                <span>
                  <span className="leader-con-breakdown-name">{company.name}</span>
                  <span style={{ display: 'block', fontSize: '12px', color: '#6B7280', marginTop: '2px' }}>
                    Users: {company.totalUsers ?? 0} | Active: {company.activeUsers ?? 0} | Runs: {company.totalRuns ?? 0} | Bookings: {company.totalBookings ?? 0}
                  </span>
                </span>
                <span className="lead-company-region-badge">{company.region || '-'}</span>
              </button>
            </li>
          ))}
        </ul>
        {filtered.length === 0 && (
          <p className="leader-con-modal-no-data">No companies match your search.</p>
        )}
      </div>
    </Modal>
  );
};

export default CompaniesModal;
